<template>
  <div class="app-orders">
    <v-header v-bind:user="user"></v-header>
    <customer-list />
  </div>
</template>

<script>
import VHeader from "../components/header.vue";
import CustomerList from "../components/admin/customers/CustomersTable.vue";
import User from "@/models/User.js";

// @ is an alias to /src
export default {
  name: "app-orders",
  data() {
    return {
      user: new User(this.$session.get("user")),
    };
  },
  mounted() {
    this.checkUser();
  },
  methods: {
    checkUser() {
      if (this.user.company_id == 9) {
        this.$session.destroy();
        this.$router.push("/login").catch(() => {});
      }
      if (!this.user.hasRights("CA_NEW")) {
        this.$session.destroy();
        this.$router.push("/login").catch(() => {});
      }
    },
  },
  components: {
    VHeader,
    CustomerList,
  },
};
</script>
